import React, {useState} from 'react';
import {DialogActions, TextField} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
// @ts-ignore
import CancelButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton';
// @ts-ignore
import CreateButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CreateButton';
import Typography from "@material-ui/core/Typography";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InputRules from "../SingleHCLModelView/SingleTreeView/Inputs/InputRules";

interface Props {
	create: (title: string) => void;
	close: () => void;
}

const RiskMitigationDialog = (props: Props) => {
	const { create, close } = props;
	const [title, setTitle] = useState('');
	const isTitleInvalid = InputRules.isEmpty(title);
	return (
		<Dialog
			open={true}
			maxWidth="md"
			fullWidth
			onClose={close}
		>
			<DialogTitle>
				<Typography variant="h5" color="textPrimary">Create New Risk Mitigation</Typography>
			</DialogTitle>
			<DialogContent>
				<TextField
					value={title}
					fullWidth
					onChange={(e: any) => setTitle(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<CancelButton
					variant="outlined"
					onClick={close}
					size="large"
				>
					Cancel
				</CancelButton>
				<CreateButton
					variant="outlined"
					onClick={() => create(title)}
					size="large"
					disabled={isTitleInvalid}
				>
					Create
				</CreateButton>
			</DialogActions>
		</Dialog>
	);
};

export default RiskMitigationDialog;